export default "__VITE_ASSET__BJ8u5Rr2__"